module.exports = __webpack_public_path__ + "static/img/6.e916c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital0/6.png
// module id = JmAe
// module chunks = 1